import React, { Component } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, withRouter, Switch, Route } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
///import { compose } from "recompose";
import SecureLS from "secure-ls";
import PrivateRouter from "../Router/privateRouter.jsx";
import { saveUser, removeUser } from "../Actions/user";
import { saveToken, removeToken } from "../Actions/token";
import {
  saveServiceProvider,
  removeServiceProvider,
} from "../Actions/serviceProvider";
//Route Imports


import VendorLeadLogin from "./Login/vendorLeadLogin.jsx";
import Thanks from "./Thanks/thanks.jsx";
import {
  USERLOGIN,
  USER,
  SERVICEPROVIDERLOGIN,
  SERVICEPROVIDER,
  EXPIRY,
  TOKEN,
} from "../Constants/localStorageKeys.jsx";
import Subscriptions from "./Subscriptions/subscriptions.jsx";
import ResetPasswordRequest from "./ResetPassword/resetPasswordRequest.jsx";
import ResetPassword from "./ResetPassword/resetPassword.jsx";
import Terms from "./Terms/terms.jsx";
import PrivacyPolicy from "./PrivacyPolicy/privacyPolicy.jsx";
import './style.css'
import WorkFlow from "./WorkFlow/Index.jsx";
import NewSignup from "./SignUp/newSignup.jsx";
import MainPage from "./Pages/MainPage.jsx";
import LandingVideo from "./Pages/LandingVideo.jsx";
import Chatbot from "./Organisms/Chatbot.jsx";
import NewSubscription from "./Pages/NewSubscription.jsx";
import UnderConstruction from "./Pages/UnderConstruction.jsx";

const theme = createTheme({
  overrides: {
    MuiCardContent: {
      root: {
        paddingBottom: "4px !important",
        padding: 8,
      },
    },
  },
  palette: {
    primary: {
      main: "#b5b5b5",
    },
    secondary: {
      light: "#53A318",
      main: "#53A318",
      contrastText: "#ffcc00",
    },
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSpLoggedIn: false,
      isUserLoggedIn: false,
      isAuth: false,
      hiddenApp: true,
      uuid: ""
    };
    this.handleUserLogin = this.handleUserLogin.bind(this);
    this.handleServiceProviderLogin = this.handleServiceProviderLogin.bind(
      this
    );
    this.handleLogout = this.handleLogout.bind(this);
    this.inactivityTime();



    window.onbeforeunload = () => {
      let ls = new SecureLS();
      var expiry = new Date();
      let token = ls.get(TOKEN);
      let sp = ls.get(SERVICEPROVIDER);
      let splogin = ls.get(SERVICEPROVIDERLOGIN);
      let user = ls.get(USER);
      let userlogin = ls.get(USERLOGIN);
      expiry.setDate(expiry.getDate() + 3); // three days 
      ls.set(EXPIRY, expiry / 1000);
      ls.set(TOKEN, token);
      ls.set(SERVICEPROVIDER, sp);
      ls.set(SERVICEPROVIDERLOGIN, splogin);
      ls.set(USER, user);
      ls.set(USERLOGIN, userlogin);
    };
  }

  inactivityTime = () => {
    var time;
    window.onload = resetTimer;
    document.onmousemove = resetTimer;
    document.onkeypress = resetTimer;

    const inactiveLogout = () => {
      this.logout();
    };

    function resetTimer() {
      clearTimeout(time);
      time = setTimeout(inactiveLogout, 60 * 60 * 10000);

    }

  };

  componentWillMount() {



    // Call the function on component mount
    this.checkHiddenApp();

    this.setState({
      uuid: window.self.crypto.randomUUID(),
    })

    const localStore = new SecureLS();
    const expiryDate = localStore.get(EXPIRY);
    if (expiryDate < Date.now() / 1000) {
      let ls = new SecureLS();
      ls.remove(TOKEN);
      ls.remove(USER);
      ls.remove(USERLOGIN);
      ls.remove(SERVICEPROVIDER);
      ls.remove(SERVICEPROVIDERLOGIN);
      ls.remove(EXPIRY);
      this.props.removeUser(null);
      this.props.removeServiceProvider(null);
      this.props.removeToken(null);
    } else {
      const token = localStore.get(TOKEN);
      if (token) {
        const isUserLoggedIn = localStore.get(USERLOGIN);
        if (isUserLoggedIn) {
          this.setState({
            isUserLoggedIn: true,
            isSpLoggedIn: false,
          });
          const user = localStore.get(USER);
          this.props.saveUser(user);
          this.props.saveToken(token);
          this.props.removeServiceProvider();
        }
        const isSpLoggedIn = localStore.get(SERVICEPROVIDERLOGIN);
        if (isSpLoggedIn) {
          this.setState({
            isSpLoggedIn: true,
            isUserLoggedIn: false,
          });
          const serviceProvider = localStore.get(SERVICEPROVIDER);
          this.props.saveServiceProvider(serviceProvider);
          this.props.saveToken(token);
          this.props.removeUser();
        }
      }
    }
  }

  handleUserLogin = (data) => {
    let ls = new SecureLS();
    ls.set(TOKEN, data.access_token);
    ls.set(USER, data.user);
    ls.set(USERLOGIN, true);
    this.props.saveUser(data.user);
    this.props.saveToken(data.access_token);
    this.props.removeServiceProvider();
    this.setState({
      isUserLoggedIn: true,
      isSpLoggedIn: false,
    });
  };

  handleServiceProviderLogin = (data) => {
    //console.log(data)

    if (data.user.memberOf === "PROPAGILE") {
      let ls = new SecureLS();
      var expiry = new Date();
      expiry.setMinutes(expiry.getMinutes() + 20);
      ls.set(TOKEN, data.access_token);
      ls.set(SERVICEPROVIDER, data.user);
      ls.set(SERVICEPROVIDERLOGIN, true);
      ls.set(EXPIRY, expiry / 1000);
      localStorage.setItem("currentUserEmail", data.user.email_address);
      localStorage.setItem("currentUserUuid", data.user.uuid);
      this.props.saveServiceProvider(data.user);
      this.props.saveToken(data.access_token);
      this.props.removeUser();
      this.setState({
        isSpLoggedIn: true,
        isUserLoggedIn: false,
      });
    }

    if (data.user.memberOf === "CONNECTIONS") {


      if (this.props.signIn(
        {
          token: data.access_token,
          expiresIn: 345600,
          tokenType: "Bearer",
          authState: data.user,    // Only if you are using refreshToken feature
        }
      )) {
        // Redirect or do-something
        window.location.replace("http://localhost:3000/dashboard");
      } else {
        //Throw error
        console.log("error")
      }


    }

  };

  updateSubscription = (data) => {
    let ls = new SecureLS();
    let user = ls.get(SERVICEPROVIDER);
    user.subscription = data;
    this.props.saveServiceProvider(user);
    ls.set(SERVICEPROVIDER, user);

  }

  logout = () => {
    this.handleLogout(true);
  };

  logoutWithoutRefresh = () => {
    this.handleLogout(false);
  };

  extraAuth = (data) => {

    if (data === '005891' || data === '015668') {
      const expiryTime = new Date().getTime() + 3 * 60 * 60 * 1000; // 3 hours from now
      localStorage.setItem("hiddenApp", JSON.stringify({ value: false, expiry: expiryTime }));
      this.setState({
        hiddenApp: false
      });
    }
  }

  // Check the value of hiddenApp on page refresh
  checkHiddenApp = () => {
    const hiddenAppData = JSON.parse(localStorage.getItem("hiddenApp"));
    if (hiddenAppData) {
      const currentTime = new Date().getTime();
      if (currentTime > hiddenAppData.expiry) {
        localStorage.setItem("hiddenApp", JSON.stringify({ value: true, expiry: 0 }));
        this.setState({ hiddenApp: true });
      } else {
        this.setState({ hiddenApp: hiddenAppData.value });
      }
    } else {
      this.setState({ hiddenApp: true });
    }
  };

  handleLogout = (shouldRefresh) => {
    let ls = new SecureLS();
    ls.remove(TOKEN);
    ls.remove(USER);
    ls.remove(USERLOGIN);
    ls.remove(SERVICEPROVIDER);
    ls.remove(SERVICEPROVIDERLOGIN);
    ls.remove(EXPIRY);

    localStorage.removeItem("tab");
    localStorage.removeItem("currentUserEmail");
    localStorage.removeItem("currentUserUuid");
    this.props.removeUser(null);
    this.props.removeServiceProvider(null);
    this.props.removeToken(null);
    this.setState({
      isUserLoggedIn: false,
      isSpLoggedIn: false,
    });
    if (shouldRefresh) {
      //
      this.props.history.push("/");
      window.location.reload();

    }
  };



  render() {
    const { isUserLoggedIn, isSpLoggedIn, uuid, hiddenApp, steps, run } = this.state;



    return (

      <ThemeProvider theme={theme}>
        <div className="App">
          {/* <button onClick={this.startTour}>Iniciar Tour</button> */}
          <BrowserRouter basename="/">
            <Switch>
              <Route
                exact={true}
                path="/"
                render={(routeProps) => (
                  <UnderConstruction />
                )}
              />

              <Route
                exact={true}
                path="/workflow"
                render={() => (
                  <WorkFlow
                    isUserLoggedIn={isUserLoggedIn}
                    isSpLoggedIn={isSpLoggedIn}
                    handleServiceProviderLogin={this.handleServiceProviderLogin}
                    uuid={uuid} />
                )}
              />
              <Route
                exact={true}
                path="/resources"
                render={() => (
                  <LandingVideo />
                )}
              />
              <Route
                exact={true}
                path="/login"
                render={() => (
                  <VendorLeadLogin
                    fromApp={true}
                    isUserLoggedIn={isUserLoggedIn}
                    isSpLoggedIn={isSpLoggedIn}
                    handleServiceProviderLogin={this.handleServiceProviderLogin}
                  />
                )}
              />
              <Route
                exact={true}
                path="/sign-up"
                render={() => (
                  <NewSignup
                    isUserLoggedIn={isUserLoggedIn}
                    isSpLoggedIn={isSpLoggedIn}
                    handleServiceProviderLogin={this.handleServiceProviderLogin}
                  />
                  // <VendorSignup
                  //   isUserLoggedIn={isUserLoggedIn}
                  //   isSpLoggedIn={isSpLoggedIn}
                  //   handleServiceProviderLogin={this.handleServiceProviderLogin}
                  // />
                )}
              />

              <Route
                exact={true}
                path="/thanks"
                render={() => (
                  <Thanks
                    isSpLoggedIn={isSpLoggedIn}
                    handleLogout={this.logoutWithoutRefresh}
                    updateSubscription={this.updateSubscription}
                  />
                )}
              />
              <Route
                exact={true}
                path="/reset-password-request"
                render={() => <ResetPasswordRequest />}
              />
              <Route
                exact={true}
                path="/reset-password"
                render={() => <ResetPassword />}
              />
              <Route
                exact={true}
                path="/subscriptions"
                render={() => <Subscriptions isSpLoggedIn={isSpLoggedIn} />}
              />

              <Route
                exact={true}
                path="/terms"
                render={() => (
                  <Terms
                    isUserLoggedIn={isUserLoggedIn}
                    isSpLoggedIn={isSpLoggedIn}
                    handleLogout={this.logout}
                  />
                )}
              />
              <Route
                exact={true}
                path="/privacy-policy"
                render={() => (
                  <PrivacyPolicy
                    isUserLoggedIn={isUserLoggedIn}
                    isSpLoggedIn={isSpLoggedIn}
                    handleLogout={this.logout}
                  />
                )}
              />
              <Route
                exact={true}
                path="/subscriptions"
                render={() => <NewSubscription signout={this.logout} />} />
              <Route
                exact={true}
                path="/chatbot"
                render={() => <Chatbot signout={this.logout} />}
              />
              <Route
                exact={true}
                path="/chatbot/c/:conversationId"
                render={() => <Chatbot signout={this.logout} />} />

              <PrivateRouter
                isLoggedIn={isSpLoggedIn}
                exact={true}
                redirectionPath="/login"
                path="/dashboard"
                component={() => (
                  <MainPage
                    logout={this.logout}
                    updateSubscription={this.updateSubscription}
                  />
                )}
              />
            </Switch>
          </BrowserRouter>

        </div>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    serviceProvider: state.serviceProvider.serviceProvider,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      saveServiceProvider,
      removeServiceProvider,
      saveUser,
      removeUser,
      saveToken,
      removeToken,

    },
    dispatch
  );
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(App);
